module.exports = __webpack_public_path__ + "static/media/rotary.b5d6167a.png";